import addSectionUserpreferences from './getUserPreferences/addSectionUserpreferences';

export default (params) => {
  const { fieldType } = params;

  if (fieldType === 'userPreferences') {
    const sectionsToAdd = [
      {
        title: 'Extra Curricular Activities',
        sectionKey: 'extraCurricular',
      },
    ];
    return addSectionUserpreferences(params, sectionsToAdd);
  }

  return null;
};
